/* eslint-disable */

import { css, StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useGetRequest, useInfiniteScroll, useLoad } from '../../hooks/request'
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import BuildingCreate from "./BuildingCreate";
import { BUILDING_LIST } from "../../urls";
import Loader from "../../components/common/Loader";
import BuildingItem from "./BuildingItem";
import { format } from "../../utils/number";


export default function Building() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})
    const [filters, setFilters] = useState({
        expense_date_month: '',
        expense_date_year: new Date().getFullYear()
    })
    const [showFilters, setShowFilters] = useState(false)

    const searchParam = useQueryParams()
    const expense = useInfiniteScroll({
        url: BUILDING_LIST,
        params: { page, ...params, ...filters, ...searchParam }
    }, [searchParam, page, params, filters])

    const summary = useLoad(
        {
            url: '/main/building/summary',
            params: { ...filters }
        },
        [filters]
    )

    const handleFilterChange = (name, value) => {
        setFilters(prev => ({
            ...prev,
            [name]: value
        }))
        setPage(1)
    }

    const clearFilters = () => {
        setFilters({
            expense_date_month: '',
            expense_date_year: new Date().getFullYear()
        })
        setPage(1)
    }

    const months = [
        { value: 1, label: 'Янvar' },
        { value: 2, label: 'Fevral' },
        { value: 3, label: 'Mart' },
        { value: 4, label: 'Aprel' },
        { value: 5, label: 'May' },
        { value: 6, label: 'Iyun' },
        { value: 7, label: 'Iyul' },
        { value: 8, label: 'Avgust' },
        { value: 9, label: 'Sentabr' },
        { value: 10, label: 'Oktabr' },
        { value: 11, label: 'Noyabr' },
        { value: 12, label: 'Dekabr' }
    ]

    const productList = expense.response ? expense.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<BuildingCreate expenseReport={expense}
                                                                           onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title">Домлар</h1>
                <div className="is-flex">
                    <Button
                        text={showFilters ? "Фильтрни ёпиш" : "Фильтр"}
                        className="button is-info is-outlined mr-2"
                        onClick={() => setShowFilters(!showFilters)}
                    />
                    <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
                </div>
            </div>

            {/* Filter Section */}
            {showFilters && (
                <div className="box mb-4">
                    <h3 className="subtitle is-5 mb-3">Харажат санаси бўйича фильтр</h3>

                    <div className="columns">
                        <div className="column is-4">
                            <label className="label">Ой</label>
                            <div className="select is-fullwidth">
                                <select
                                    value={filters.expense_date_month}
                                    onChange={e => handleFilterChange('expense_date_month', e.target.value)}
                                >
                                    <option value="">Барча ойлар</option>
                                    {months.map(month => (
                                        <option key={month.value} value={month.value}>{month.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="column is-4">
                            <label className="label">Йил</label>
                            <input
                                className="input"
                                type="number"
                                value={filters.expense_date_year}
                                onChange={e => handleFilterChange('expense_date_year', e.target.value)}
                                placeholder="Йилни киритинг"
                            />
                        </div>

                        <div className="column is-4">
                            <label className="label">&nbsp;</label>
                            <div className="field">
                                <Button
                                    text="Фильтрни тозалаш"
                                    className="button is-light"
                                    onClick={clearFilters}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="columns is-mobile is-multiline">
                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0fff4',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-success has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-down-outline" />
                                <b className="ml-2">Кирим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(summary.response ? summary.response.totalIncomeSum : 0)} UZS</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#fff5f5',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-danger has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-up-outline" />
                                <b className="ml-2">Чиқим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(summary.response ? summary.response.totalExpenseSum : 0)} UZS</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f7ff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-info has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="wallet-outline" />
                                <b className="ml-2">Баланс:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(summary.response ? summary.response.totalBalanceSum : 0)} UZS</span>
                        </p>
                    </div>
                </div>
            </div>

            <div>

                {!expense.loading ? (
                    <div className="">
                        {expense.response && expense.response.count === 0 ? (
                            <div className="is-flex is-justify-content-center is-align-items-center">

                            </div>
                        ) : (
                            <div className="columns is-multiline">
                                {productList.map((house, index) => (
                                    <BuildingItem expense={expense} house={house} index={index}/>
                                ))}
                            </div>

                        )}
                        <div ref={expense.ref} className="has-text-grey-light is-italic has-text-centered">
                            {!expense.hasMore && !expense.loading && expense.length !== 0 ? 'Барча домлар юкланган' : ''}
                        </div>
                    </div>
                ) : (
                    <Loader className={css(styles.loader)} large center/>
                )}
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
